import { render } from "./SpecialsImages.vue?vue&type=template&id=2c4feeb8"
import script from "./SpecialsImages.vue?vue&type=script&lang=js"
export * from "./SpecialsImages.vue?vue&type=script&lang=js"

import "./SpecialsImages.vue?vue&type=style&index=0&id=2c4feeb8&lang=css"

import exportComponent from "/var/www/cms.dealersgear.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__